// extracted by mini-css-extract-plugin
module.exports = {"container":"relevant-analytics_container__MksJq","title":"relevant-analytics_title__oblW0"};